/**
 * Checks that the first six characters of a PO number are numeric.
 * PO numbers may have alphanumeric suffixes, but must always start with six digits.
 *
 * @param poValue - The PO number as a string.
 * @returns True if the first six characters parse as a number.
 */
export function poFirst6IsNumeric(poValue: string): boolean {
  const first6Chars = poValue.substring(0, 6);
  return !isNaN(Number(first6Chars));
}
